/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LocationMethod {
  GPS = "gps",
  MAP_CLICK = "map_click",
}
